import React, { useState, useEffect } from 'react'
import { error } from '../../constants/msg'
import { GetPrivacyPolicy, GetTermsAndConditions } from '../../services/pages/pages'
import Loader from '../loader/Loader'

const TermsAndConditions = () => {
    const [data, setData] = useState("")
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const getTermsAndConditions = async () => {
            setIsLoading(true)
            try {
                const res = await GetTermsAndConditions()
                setData(res?.data?.data?.content)
                setIsLoading(false)
            }
            catch (e) {
                setIsLoading(false)
                error(e.response.data.message)
            }
        }

        getTermsAndConditions()
    }, [])

    return (
        <>
            {
                isLoading ?
                    <Loader />
                    :
                    <p>
                        {data}
                    </p>
            }
        </>
    )
}

export default TermsAndConditions